<template>
  <div v-if="inital">
    <router-view></router-view>
  </div>
</template>
<script>


import { mapState } from "vuex";

export default {
  data: () => ({
    inital: true
  }),

};
</script>
